export default {
    productVisualized: null,
    loading: true,
    loadingDownloadAttachment: {
        id: null,
        status: false
    }
}
